// src/servicios/RutaProtegida.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './store';
import Loader from '../componentes/Loader';

const RutaProtegida = ({ children, rolesPermitidos }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loader fullscreen={true} />;

  // Redirección si no está autenticado
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Validación unificada del estado (ambos roles usan "estado" como string)
  if (currentUser.estado !== 'activo') {
    return <Navigate to="/cuenta-desactivada" replace />;
  }

  // Redirección por rol no autorizado
  if (!rolesPermitidos.includes(currentUser.rol)) {
    const rutaRedireccion = currentUser.rol === 'superadmin' 
      ? '/admin-panel' 
      : '/estudiante-home';
    return <Navigate to={rutaRedireccion} replace />;
  }

  return children;
};

export default RutaProtegida;